import { render } from "./CartButton.vue?vue&type=template&id=52395070&scoped=true&ts=true"
import script from "./CartButton.vue?vue&type=script&lang=ts"
export * from "./CartButton.vue?vue&type=script&lang=ts"

import "./CartButton.vue?vue&type=style&index=0&id=52395070&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52395070"]])

export default __exports__